import { PageEvents } from '@griply/types';
import Dialog from '@mui/material/Dialog';
import React, { Suspense, useDeferredValue, useState } from 'react';
import { DialogVariantOptions } from 'shared/assets/styles';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';

import { LoadingSearchResults } from './loading-search-results';
import { RecentVisits } from './recent-visits';
import { SearchBar } from './search-bar';
import * as Styled from './search-dialog.style';
import { SearchResults } from './search-results';

export type SearchDialogProps = {
  open?: boolean;
  onShowPage: (searchValue: string) => void;
  onClose: () => void;
};

export const SearchDialog: React.FC<SearchDialogProps> = ({
  open,
  onShowPage,
  onClose,
}) => {
  useTrackPageVisitEvent(PageEvents.SearchDialog, undefined);
  const [dialogSearchValue, setDialogSearchValue] = useState('');
  const deferredSearchValue = useDeferredValue(dialogSearchValue);

  const _onShowPage = (value: string) => onShowPage(value);

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      fullWidth
      variant={DialogVariantOptions.MediumSmall}
    >
      <SearchBar
        value={deferredSearchValue}
        onChange={setDialogSearchValue}
        onShowPage={_onShowPage}
        autoFocusInput
      />

      <Styled.Body>
        {deferredSearchValue !== dialogSearchValue ? (
          <LoadingSearchResults />
        ) : !!deferredSearchValue ? (
          <Suspense fallback={<LoadingSearchResults />}>
            <SearchResults
              searchValue={deferredSearchValue}
              onClose={onClose}
            />
          </Suspense>
        ) : (
          <RecentVisits onClose={onClose} />
        )}
      </Styled.Body>
    </Dialog>
  );
};
